var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Model, { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

export let COMMAND_STEP_STATUS = /*#__PURE__*/function (COMMAND_STEP_STATUS) {
  COMMAND_STEP_STATUS["SUCCESS"] = "SUCCESS";
  COMMAND_STEP_STATUS["FAILED"] = "FAILED";
  COMMAND_STEP_STATUS["ERROR"] = "ERROR";
  COMMAND_STEP_STATUS["STARTED"] = "STARTED";
  return COMMAND_STEP_STATUS;
}({});
export let COMMAND_STEP_NAME = /*#__PURE__*/function (COMMAND_STEP_NAME) {
  COMMAND_STEP_NAME["GOOGLE_UPDATE_WEBSITE_URL"] = "GOOGLE_UPDATE_WEBSITE_URL";
  COMMAND_STEP_NAME["GOOGLE_CREATE_AND_LINK_ACCOUNT"] = "GOOGLE_CREATE_AND_LINK_ACCOUNT";
  COMMAND_STEP_NAME["GOOGLE_APPROVE_ACCOUNT_LINK"] = "GOOGLE_APPROVE_ACCOUNT_LINK";
  COMMAND_STEP_NAME["GOOGLE_RETRIEVE_VERIFICATION_TOKEN"] = "GOOGLE_RETRIEVE_VERIFICATION_TOKEN";
  COMMAND_STEP_NAME["GOOGLE_VERIFY_AND_CLAIM_WEBSITE"] = "GOOGLE_VERIFY_AND_CLAIM_WEBSITE";
  COMMAND_STEP_NAME["GOOGLE_SET_MERCHANT_CENTER_ACCOUNT"] = "GOOGLE_SET_MERCHANT_CENTER_ACCOUNT";
  COMMAND_STEP_NAME["SETUP_GOOGLE_LOCAL_INVENTORY_ADS_GMB_LINK"] = "SETUP_GOOGLE_LOCAL_INVENTORY_ADS_GMB_LINK";
  COMMAND_STEP_NAME["SETUP_GOOGLE_LOCAL_INVENTORY_ADS_TARGET_COUNTRY"] = "SETUP_GOOGLE_LOCAL_INVENTORY_ADS_TARGET_COUNTRY";
  COMMAND_STEP_NAME["SETUP_GOOGLE_LOCATION_OBJECT_MAP"] = "SETUP_GOOGLE_LOCATION_OBJECT_MAP";
  COMMAND_STEP_NAME["META_COMMERCE_GET_FBE_INSTALLATION_DETAILS_STEP"] = "META_COMMERCE_GET_FBE_INSTALLATION_DETAILS_STEP";
  COMMAND_STEP_NAME["META_COMMERCE_INSTALL_PIXEL"] = "META_COMMERCE_INSTALL_PIXEL";
  COMMAND_STEP_NAME["META_COMMERCE_DOMAIN_VERIFICATION"] = "META_COMMERCE_DOMAIN_VERIFICATION";
  COMMAND_STEP_NAME["PUBLISH_ALL_LISTINGS"] = "PUBLISH_ALL_LISTINGS";
  COMMAND_STEP_NAME["UPSERT_CATALOG_CUSTOM_ATTRIBUTES"] = "UPSERT_CATALOG_CUSTOM_ATTRIBUTES";
  return COMMAND_STEP_NAME;
}({});
let CommandStep = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('string'), _dec4 = attr('number'), _dec5 = attr('json-or-value'), _dec6 = attr('date'), _dec7 = attr('date'), _dec8 = attr('string'), _dec9 = attr('date'), _dec10 = attr('number'), _dec11 = attr('string'), _dec12 = attr('date'), _dec13 = attr('date'), _dec14 = attr('date'), _dec15 = belongsTo('channels/command'), _dec16 = computed('status'), _dec17 = computed('status'), _dec18 = computed('status'), (_class = class CommandStep extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantId", _descriptor, this);
    _initializerDefineProperty(this, "commandId", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "executionOrder", _descriptor4, this);
    _initializerDefineProperty(this, "payload", _descriptor5, this);
    _initializerDefineProperty(this, "startedAt", _descriptor6, this);
    _initializerDefineProperty(this, "processedAt", _descriptor7, this);
    _initializerDefineProperty(this, "status", _descriptor8, this);
    _initializerDefineProperty(this, "lastErroredAt", _descriptor9, this);
    _initializerDefineProperty(this, "attempted", _descriptor10, this);
    _initializerDefineProperty(this, "errorDescription", _descriptor11, this);
    _initializerDefineProperty(this, "createdAt", _descriptor12, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor13, this);
    _initializerDefineProperty(this, "deletedAt", _descriptor14, this);
    _initializerDefineProperty(this, "command", _descriptor15, this);
  }
  get isStatusSuccess() {
    return this.status === COMMAND_STEP_STATUS.SUCCESS;
  }
  get isStatusFailed() {
    return this.status === COMMAND_STEP_STATUS.FAILED;
  }
  get isStatusError() {
    return this.status === COMMAND_STEP_STATUS.ERROR;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "commandId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "executionOrder", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "payload", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "startedAt", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "processedAt", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "lastErroredAt", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "attempted", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "errorDescription", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "deletedAt", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "command", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isStatusSuccess", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusFailed", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusFailed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusError", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusError"), _class.prototype)), _class));
export { CommandStep as default };